import { __assign, __spreadArray } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-spacing.css';

var getClassNameList = classNames.bind(styles);
var UitkSpacing = function (props) {
    var border = props.border, className = props.className, margin = props.margin, padding = props.padding, stid = props.stid, style = props.style;
    var childrenArray = React.Children.toArray(props.children);
    var firstChild = childrenArray[0];
    if (!firstChild || typeof firstChild !== 'object' || !('props' in firstChild)) {
        return null;
    }
    var firstChildClassName = firstChild.props.className;
    var firstChildStyle = firstChild.props.style;
    var makeRecursiveClass = function (obj, propName, classPrefix, nonen) {
        if (nonen === void 0) { nonen = false; }
        var arr = [];
        var objIsArray = Array.isArray(obj);
        Object.getOwnPropertyNames(obj).forEach(function (val) {
            if (typeof obj[val] === 'object' && obj[val] !== null) {
                arr.push(makeRecursiveClass(obj[val], propName, classPrefix, val));
            }
            else {
                var classArr = __spreadArray(__spreadArray(__spreadArray([classPrefix, propName], (nonen ? [nonen] : []), true), (objIsArray ? [] : [val]), true), [obj[val]], false);
                // Don't push if the array contains the array index
                typeof obj[val] !== 'number' && arr.push(classArr.join('-'));
            }
        });
        return arr.join(' ');
    };
    var makeClass = function (input, propName, classPrefix) {
        var inputType = typeof input;
        if (inputType === 'string') {
            return "".concat(classPrefix, "-").concat(propName, "-").concat(input);
        }
        if (inputType === 'boolean') {
            return "".concat(classPrefix, "-").concat(propName);
        }
        return makeRecursiveClass(input, propName, classPrefix);
    };
    var wrapperStyle = __assign(__assign({}, firstChildStyle), style);
    var baseClass = 'uitk-spacing';
    var wrapperClassNames = getClassNameList([
        baseClass,
        firstChildClassName,
        margin && "".concat(makeClass(margin, 'margin', baseClass)),
        padding && "".concat(makeClass(padding, 'padding', baseClass)),
        border && "".concat(makeClass(border, 'border', baseClass)),
        className
    ]);
    var decoratedChild = React.cloneElement(firstChild, __assign(__assign({ className: wrapperClassNames }, (stid && { 'data-stid': stid })), (Object.keys(wrapperStyle).length && {
        style: wrapperStyle
    })));
    return decoratedChild;
};
UitkSpacing.displayName = 'UitkSpacing';

export { UitkSpacing };
